import React from "react";
import { withNavigation } from '../Components/helpers/withNavigation';
import {Form } from 'reactstrap';
import '../App.css';
import Body from '../Components/layout/Body';
import {PerformTrainingPageControls} from '../Components/layout/PerformTrainingPage';
import {InformationPageContent} from '../Components/layout/InformationPage';
import {CheckListContent} from '../Components/layout/CheckListPage';
import TrainingNavigation from "../Components/layout/TrainingNavigation";
import { isGuid } from '../App.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlayCircle } from '@fortawesome/free-solid-svg-icons';
import { TourProvider } from '@reactour/tour';
import { TourBridge, SkipHiddenTourSteps } from '../utils/TourHelpers.js';

function PerformTrainingWithTour(props){
  const steps= [
    {
      selector:'.function-bar',
      content:(
      <>
        <p>- Home makes the app go back to selecting trainings on the homepage</p>
        <p>- Help to show this tour again.</p>
      </>
      )
    },
    {
      selector: '.instruct-navigation-listgroup',
      content:(
      <>
        <p>- This is the navigation sidebar showing the steps in the current training.</p>
        <p>- You can select any step to navigate directly to it.</p>
      </>
      ),
    },{
      selector: '.main-form',
      content:(
        <>
          <p>- This is the main content area showing the media for the current training step.</p>
          <p>- You can play the video or audio, and view images or information related to the step.</p>
        </>
      ),
    },
    {
      selector: '.instruct-control-container',
      content:(
        <>
          <p>- Use the Previous and Next buttons to navigate between training steps.</p>
          <p>- Use the Play/Pause button to control media playback.</p>
          <p>- Use the Restart button to go back to the first step of the training.</p>
          <p>- Use the playback speed controls to adjust the speed of audio playback.</p>
        </>      
      ),
    }
  ]
  return (
    <div className={'training-container'}>
      <TourProvider 
        steps={steps} 
        padding={10} 
        showBadge={false}
        scrollSmooth 
        className="my-custom-tour" 
        onClickClose={() => {props.updateState({showTour: false});}} 
        onClickMask={() => {props.updateState({showTour: false});}} 
      >
        <SkipHiddenTourSteps/>
        <TourBridge showTour={props.showTour} incognitoBrowser={props.incognitoBrowser} updateState={props.updateState}>
          <PerformTraining {...props} />
        </TourBridge>
      </TourProvider>
    </div>
  );
}

class PerformTraining extends React.Component {

   constructor(props){
      super(props);

      this.state = {
        // trainingName: params.get('id'),
        training: this.props.currentTraining,
        currentStep: 0,
        mediaCompleted:false,
        playbackSpeed:1.0,
        savedAudioSpeed:1.0,
        imageLoaded: false,
        previousDisabled:true,
        useDarkMode: true,
        resolvedVideoSrc: null,
        resolvedAudioSrc: null,
        resolvedImageSrc: null,
      };

      // this.videoPlayer = React.createRef();
      // this.audioPlayer = React.createRef();
  
      this.onItemClick = this.onItemClick.bind(this);
      this.onDecreaseSpeedClick = this.onDecreaseSpeedClick.bind(this);
      this.onIncreaseSpeedClick = this.onIncreaseSpeedClick.bind(this);
      this.onMediaControlClick = this.onMediaControlClick.bind(this);
      this.onRestartClick = this.onRestartClick.bind(this);
      this.onPreviousClick = this.onPreviousClick.bind(this);
      this.onReplayClick = this.onReplayClick.bind(this);
      this.onNextClick = this.onNextClick.bind(this);
      this.onMediaEnded = this.onMediaEnded.bind(this);
      this.onProgressChanged = this.onProgressChanged.bind(this);
      this.onPlay = this.onPlay.bind(this);
      this.onPause = this.onPause.bind(this);
      this.onReady = this.onReady.bind(this);

      this.contentContainer = React.createRef();
      this.imgElement = React.createRef();
    }

    componentDidMount(){
      this.resolveAudio(this.state.training?.Steps?.[this.state.currentStep].AudioFilepath);
      this.resolveVideo(this.state.training?.Steps?.[this.state.currentStep].VideoFilepath);
      this.resolveImage(this.state.training?.Steps?.[this.state.currentStep].ImagePath);
      this.setState({isAwaitingFirstPlay: this.state.training?.Steps?.[this.state.currentStep].AudioFilepath});
    }

    componentDidUpdate(prevProps, prevState) {
      if (prevState.training?.Steps?.[prevState.currentStep].AudioFilepath !== this.state.training?.Steps?.[this.state.currentStep].AudioFilepath) {
        this.resolveAudio(this.state.training?.Steps?.[this.state.currentStep].AudioFilepath);
      }
      if (prevState.training?.Steps?.[prevState.currentStep].VideoFilepath !== this.state.training?.Steps?.[this.state.currentStep].VideoFilepath) {
        this.resolveVideo(this.state.training?.Steps?.[this.state.currentStep].VideoFilepath);
      }
      if (prevState.training?.Steps?.[prevState.currentStep].ImagePath !== this.state.training?.Steps?.[this.state.currentStep].ImagePath) {
        this.resolveImage(this.state.training?.Steps?.[this.state.currentStep].ImagePath);
      }
      if(prevState.playbackSpeed !== this.state.playbackSpeed){
        // if(this.videoPlayer){
        //   this.videoPlayer.playbackRate = this.state.playbackSpeed;
        // }
        if(this.audioPlayer){
          this.audioPlayer.playbackRate = this.state.playbackSpeed;
        }
      }
    }

    componentWillUnmount() {
    }
    
  async resolveAudio(audioFilePath) {
    if (!audioFilePath) {
      this.setState({ resolvedAudioSrc: null });
      return;
    }

    if (isGuid(audioFilePath)) {
      try {
        const media = await this.props.getMediaById(audioFilePath);
        if (!this._cancelled && media?.file) {
          const ab = await media.file.arrayBuffer();
          const header = new Uint8Array(ab.slice(0, 12));
          console.warn([...header].map(b => String.fromCharCode(b)).join(''));
          const url = URL.createObjectURL(media.file);
          this.setState({ resolvedAudioSrc: url });
        }
      } catch (err) {
        console.error("Failed to load audio:", err);
        if (!this._cancelled) {
          this.setState({ resolvedAudioSrc: null });
        }
      }
    } else {
      this.setState({ resolvedAudioSrc: audioFilePath });
    }
  }

  async resolveVideo(videoFilePath) {
    if (!videoFilePath) {
      this.setState({ resolvedVideoSrc: null });
      return;
    }

    if (isGuid(videoFilePath)) {
      try {
        const media = await this.props.getMediaById(videoFilePath);
        if (!this._cancelled && media?.file) {
          const url = URL.createObjectURL(media.file);
          this.setState({ resolvedVideoSrc: url });
        }
      } catch (err) {
        console.error("Failed to load audio:", err);
        if (!this._cancelled) {
          this.setState({ resolvedVideoSrc: null });
        }
      }
    } else {
      this.setState({ resolvedVideoSrc: videoFilePath });
    }
  }

  async resolveImage(imageFilePath) {
    if (!imageFilePath) {
      this.setState({ resolvedImageSrc: null });
      return;
    }

    if (isGuid(imageFilePath)) {
      try {
        const media = await this.props.getMediaById(imageFilePath);
        if (!this._cancelled && media?.file) {
          const url = URL.createObjectURL(media.file);
          this.setState({ resolvedImageSrc: url });
        }
      } catch (err) {
        console.error("Failed to load audio:", err);
        if (!this._cancelled) {
          this.setState({ resolvedImageSrc: null });
        }
      }
    } else {
      this.setState({ resolvedImageSrc: imageFilePath });
    }
  }
  
    onItemClick(item){ 
      this.stopMediaPlayback();
      this.setState({
        currentStep: item.Index,
        imageLoaded: false,
        playbackSpeed: item.VideoFilepath ? 1.0 : this.state.savedAudioSpeed,
        previousDisabled: item.Index <= 0,
        nextDisabled: item.Index >= this.state.training?.Steps?.length - 1,
        isAwaitingFirstPlay: this.state.isAwaitingFirstPlay && item.Index <= 0
      });
    }

    stopMediaPlayback(){
      if(this.videoPlayer)
        this.videoPlayer.pause();
      if(this.audioPlayer){
        this.audioPlayer.pause();
      }
      this.setState({mediaCompleted: true});
    }

    onDecreaseSpeedClick(){
      var curStep = this.state.training?.Steps?.[this.state.currentStep];
      if(curStep.AudioFilepath){
        let newSpeed = Math.max(this.state.playbackSpeed * 0.9, 0.5);
        this.setState({
          playbackSpeed: newSpeed,
          savedAudioSpeed: newSpeed,
          decreaseDisabled: newSpeed <= 0.5,
          increaseDisabled: newSpeed >= 1.4
        });
      }else{
        this.setState({
          playbackSpeed: 1.0,
          decreaseDisabled: false,
          increaseDisabled: false
        });
      }
     }
    onIncreaseSpeedClick(){ 
      var curStep = this.state.training?.Steps?.[this.state.currentStep];
      if(curStep.AudioFilepath){
        let newSpeed = Math.min(this.state.playbackSpeed * 1.1, 2.0);
        this.setState({
          playbackSpeed: newSpeed,
          savedAudioSpeed: newSpeed,
          decreaseDisabled: newSpeed <= 0.5,
          increaseDisabled: newSpeed >= 2.0
        });
      }else{
        this.setState({
          playbackSpeed: 1.0,
          decreaseDisabled: false,
          increaseDisabled: false
        });
      }
    }

    onMediaControlClick(stop){ 
      if(this.state.resolvedVideoSrc){
        if(this.videoPlayer.paused){ this.videoPlayer.play(); }
        else{ this.videoPlayer.pause(); }
      }
      else if(this.state.resolvedAudioSrc){
        if(this.audioPlayer.paused){ this.audioPlayer.play(); }
        else{ this.audioPlayer.pause(); }
      }
      if(stop)
        this.stopMediaPlayback();
    }
    onRestartClick(){
      this.stopMediaPlayback();
      this.setState({
        currentStep: 0,
        imageLoaded: false,
        playbackSpeed: this.state.savedAudioSpeed,
        previousDisabled: true,
        nextDisabled: false,
        isAwaitingFirstPlay: this.state.isAwaitingFirstPlay
      });
    }
    onPreviousClick(){
      this.stopMediaPlayback();
      var newStep = this.state.currentStep - 1;
      this.setState({
        currentStep: newStep,
        imageLoaded: false,
        playbackSpeed: this.state.training?.Steps?.[newStep].VideoFilepath ? 1.0 : this.state.savedAudioSpeed,
        previousDisabled: newStep <= 0,
        nextDisabled: newStep >= this.state.training?.Steps?.length - 1,
        isAwaitingFirstPlay: this.state.isAwaitingFirstPlay && newStep <= 0
      });
    }
    onReplayClick(){
      this.stopMediaPlayback();
      if(this.state.resolvedVideoSrc){
        //this.videoPlayer.seekTo(this.state.step.Start / 1000, 'seconds');
        const curStep = this.state.training?.Steps?.[this.state.currentStep];
        this.seekMediaTo( curStep.Start > 0 ? curStep.Start / 1000 : 0);
        this.videoPlayer.play();
      }else if(this.state.resolvedAudioSrc){
        //this.audioPlayer.seekTo(0, 'seconds');
        this.seekMediaTo(0);
        this.audioPlayer.play();
      }
      this.setState({mediaCompleted: false});
    }
    onNextClick(){
      this.stopMediaPlayback();
      var newStep = this.state.currentStep + 1;
      this.setState({
        currentStep: newStep,
        imageLoaded: false,
        playbackSpeed: this.state.training?.Steps?.[newStep].VideoFilepath ? 1.0 : this.state.savedAudioSpeed,
        previousDisabled: newStep <= 0,
        nextDisabled: newStep >= this.state.training?.Steps?.length - 1,
        isAwaitingFirstPlay: this.state.isAwaitingFirstPlay && newStep <= 0
      });
    }
    seekMediaTo = (seconds) => {
      if (this.videoPlayer && this.state.resolvedVideoSrc) {
        if('fastSeek' in this.videoPlayer)
          this.videoPlayer.fastSeek(seconds, 'seconds');
        else
          this.videoPlayer.currentTime = seconds;
      }
      if(this.audioPlayer && this.state.resolvedAudioSrc){
        if('fastSeek' in this.audioPlayer)
          this.audioPlayer.fastSeek(seconds, 'seconds');
        else
          this.audioPlayer.currentTime = seconds;
      }
    }
    onMediaEnded(){
      this.setState({mediaCompleted: true});
      if(this.state.training?.Steps?.[this.state.currentStep + 1]?.VideoFilepath){
        setTimeout(() => { 
          if(this.state.training?.Steps?.[this.state.currentStep + 1]?.VideoFilepath)
            this.onNextClick(); 
        }, 2000);
      }
    }

    onProgressChanged = (state) => {
      if(this.state.resolvedVideoSrc){
        const curStep = this.state.training?.Steps?.[this.state.currentStep];
        if( (curStep.End / 1000) < this.videoPlayer.duration &&  state.playedSeconds >= (curStep.End / 1000)){
          this.videoPlayer.pause();
        }
      }
      this.setState(state);
    }

    onPlay = () => { 
      if(this.videoPlayer != null && this.state.resolvedVideoSrc){
        const curStep = this.state.training?.Steps?.[this.state.currentStep];
        if(this.videoPlayer.currentTime * 1000 < curStep.Start){
          this.seekMediaTo(curStep.Start / 1000, 'seconds');
        }
      }
      this.setState({
        isAwaitingFirstPlay: false,
        mediaCompleted: false
      }); 
    }

    onPause = () => { }
    onReady(){
      if(this.state.resolvedVideoSrc){
        if(!this.videoPlayer.paused || this.state.isAwaitingFirstPlay){ return; }
        this.videoPlayer.play();
        this.setState({mediaCompleted: false});
      }else if(this.state.resolvedAudioSrc){
        if(!this.audioPlayer.paused || this.state.isAwaitingFirstPlay){ return; }
        this.audioPlayer.play();
        this.setState({mediaCompleted: false});
      }
    }

    fitImageInParent = () => {
      const imageElement = this.imgElement.current;
      const parentContainer = this.contentContainer.current;
  
      if (!imageElement || !parentContainer) return;
  
      const parentWidth = parentContainer.parentElement.clientWidth;
      const parentHeight = parentContainer.parentElement.clientHeight;
      const imageAspect = imageElement.naturalWidth / imageElement.naturalHeight;
      const parentAspect = parentWidth / (parentHeight); //1.25; //73 / 40;

      const findNewWidth = parentAspect !== Infinity && parentAspect < 2 && imageElement.naturalWidth > parentWidth && imageElement.naturalHeight > parentHeight;
      const width = findNewWidth ? Math.min(100, (imageAspect/parentAspect)*100) : 100;
  
      parentContainer.style.maxWidth = width + "%";
      parentContainer.style.marginLeft = (width === 100 ? 0 : parentWidth * ((100 - width)/200)) + 'px';
      console.log("done fitting image: imageAspect:{" + imageAspect + "} parentAspect:{" + parentAspect + "} width:{" + width + "}");
    };
  
    handleImageLoad = () => {
      this.setState({ imageLoaded: true }, () => {
        this.fitImageInParent();
      });
    };
  
  render(){
    console.log("rendering PerformTraining, with props: ",this.props, " state: ", this.state);
    console.log("audioPlayer=", this.audioPlayer, " videoPlayer=", this.videoPlayer);

    return(
      <Body 
        contentComponent={
          <Form 
            id='main-form'
            className='main-form'>
            {this.state.isAwaitingFirstPlay && (
              <div className="media-overlay" onClick={() => {this.audioPlayer.play(); this.setState({isAwaitingFirstPlay: false});}}>
                <button className="play-button-overlay" >
                    <FontAwesomeIcon icon={faPlayCircle} style={{ fontSize: '80px' }} />
                </button>
              </div>
            )}
            {this.state.resolvedVideoSrc ? 
              <div id='video-container'
                ref={contentContainer =>{ this.contentContainer = contentContainer}} 
                className='content-container d-flex justify-content-center align-items-center'>
                  <video
                    ref={videoPlayer => { this.videoPlayer = videoPlayer }}
                    src={this.state.resolvedVideoSrc}
                    style={{
                      width: "95%",
                      height: "95%",
                      maxWidth: "95%",
                      maxHeight: "95%",
                      objectFit: "contain",
                      display: "block"
                    }}
                    playbackRate={this.state.playbackSpeed}
                    onEnded={this.onMediaEnded}
                    onPlay={this.onPlay}
                    onPause={this.onPause}
                    onLoadedMetadata={this.onReady}
                    onTimeUpdate={(e) => {
                    const playedSeconds = e.target.currentTime;
                    this.onProgressChanged({ playedSeconds });
                    }}
                    onError={(e) => {
                      console.error("Error playing video:", this.state.resolvedVideoSrc, " Error=", e);
                    }}
                  />
                </div>
            :
              <div               
                id='content-container' 
                className='content-container justify-content-center align-items-center'>
                {this.state.training?.Steps?.[this.state.currentStep].StepType === 2 && 
                  !this.state.resolvedImageSrc && 
                  <InformationPageContent 
                    slideTitle={this.state.training?.Steps?.[this.state.currentStep].Title}
                    information={this.state.training?.Steps?.[this.state.currentStep].Information}
                    contentImage={this.state.training?.Steps?.[this.state.currentStep].ContentImagePath}
                    getMediaById={this.props.getMediaById}
                  />
                }
                {this.state.training?.Steps?.[this.state.currentStep].StepType === 3 && 
                  !this.state.resolvedImageSrc && 
                  <CheckListContent 
                    steps={this.state.training.CheckList}
                    currentStep={this.state.training?.Steps?.[this.state.currentStep].Title}
                    trainingTitle={this.state.training.Title}
                  />
                }
                {this.state.resolvedImageSrc && 
                  <div id='image-container'
                    ref={this.contentContainer} 
                    className='border content-container justify-content-center align-items-center'>
                    <img 
                      id="image-element"
                      ref={this.imgElement} 
                      className="content-image" 
                      src={this.state.resolvedImageSrc} 
                      alt={this.state.training?.Steps?.[this.state.currentStep].Title}
                      style={{ display: this.state.imageLoaded ? 'block' : 'none' }}
                      onLoad={this.handleImageLoad}
                    />
                  </div>
                }
                <audio 
                  ref={audioPlayer => {this.audioPlayer = audioPlayer}} 
                  src={this.state.resolvedAudioSrc} 
                  controls={false}
                  autoPlay={!this.state.isAwaitingFirstPlay}
                  playbackRate={this.state.playbackSpeed} 
                  onEnded={this.onMediaEnded}
                  onTimeUpdate={this.onProgressChanged}
                  onPlay={this.onPlay}
                  onPause={this.onPause}
                  onCanPlay={this.onReady}
                  onError={(e) => {
                    console.error("Error with audio:", this.state.resolvedAudioSrc, " error=",e);
                  }}
                />

              </div>
            }
        </Form>
        }
        sidebarComponent = 
        {this.state.training?.Steps?.length > 0 && (
          <TrainingNavigation 
            steps={this.state.training.Steps}
            currentStep={this.state.currentStep}
            handleItemClick={this.onItemClick}
          />
        )}
        controlsComponent = {
          <PerformTrainingPageControls 
            playingMedia={(this.state.resolvedVideoSrc || this.state.resolvedAudioSrc) && !this.state.mediaCompleted}
            description={this.state.training?.Steps?.[this.state.currentStep].Title}
            isPlaying={(this.audioPlayer && !this.audioPlayer.paused) || (this.videoPlayer && !this.videoPlayer.paused)}
            nextDisabled={this.state.nextDisabled}
            // hideSpeedControls={this.state.resolvedVideoSrc != null}
            hideSpeedControls={true}
            replayDisabled={this.state.resolvedVideoSrc == null && this.state.resolvedAudioSrc == null}
            previousDisabled={this.state.previousDisabled}
            decreaseDisabled={this.state.decreaseDisabled}
            increaseDisabled={this.state.increaseDisabled}
            handleDecreaseSpeedClick={this.onDecreaseSpeedClick}
            handleIncreaseSpeedClick={this.onIncreaseSpeedClick}
            handleMediaControlClick={this.onMediaControlClick}
            handleRestartClick={this.onRestartClick}
            handlePreviousClick={this.onPreviousClick}
            handleReplayClick={this.onReplayClick}
            handleNextClick={this.onNextClick}
          />
        }
      />
    );
  }
}
export default withNavigation(PerformTrainingWithTour);